import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import css from "./ConvertIngredients.module.css";
import * as uuid from "uuid";

function ConvertIngredients(props) {
  return (
    <div className={css.container}>
      <ToggleSwitch
        id="convertIngredientToggle"
        label="Convert Ingredients:"
        setToggleBool={props.setToggleBool}
        toggleBool={props.toggleBool}
      />
      <div
        className={
          props.toggleBool ? css.selectContainerShow : css.selectContainerHide
        }
      >
        <label className={css.label}>
          Convert to:
          <select
            className={css.select}
            name="Select measurement type"
            defaultValue="metric"
            onChange={(state) =>
              props.setSelectedMeasurement(state.target.value)
            }
          >
            <option value={"metric"}>Metric</option>
            <option value={"imperial"}>Imperial</option>
          </select>
        </label>
      </div>
    </div>
  );
}

export default ConvertIngredients;
